import {
  MOBILE_PAGE_LOG_CFG_KEYS,
  PC_PAGE_LOG_CFG_KEYS,
  CONSOLE_PAGE_LOG_CFG_KEYS,
  MINIGAME_PAGE_LOG_CFG_KEYS,
} from '@/pages/intelligence/_config/storeRank/config';
import { dbiPageLogMes, dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';

import type { IGameType } from '@/pages/intelligence/types/common';

const PAGE_LOG_CFG_KEYS: {
  [key in IGameType]: {
    [key: string]: string;
  };
} = {
  mobile: MOBILE_PAGE_LOG_CFG_KEYS,
  pc: PC_PAGE_LOG_CFG_KEYS,
  console: CONSOLE_PAGE_LOG_CFG_KEYS,
  minigame: MINIGAME_PAGE_LOG_CFG_KEYS,
};

export default function useBuriedPointLogCfgKeys(entityType: IGameType, topChartsName: string) {
  const pageLogCfgKeys = PAGE_LOG_CFG_KEYS[entityType];
  const pageLogCfgKey = pageLogCfgKeys?.[topChartsName];
  const downloadExcelLogCfgKey = `${pageLogCfgKey}DownloadExcel`;
  const pageLogCfg = dbiPageLogMes?.[pageLogCfgKey];
  const downloadExcelLogCfg = (dbiBtnLogMes as any)?.[downloadExcelLogCfgKey];

  return { pageLogCfgKey, pageLogCfg, downloadExcelLogCfgKey, downloadExcelLogCfg };
}
